export default defineNuxtPlugin(() => {
    const setMaxWidth = (sourceElement) => {
        const source = document.querySelector(sourceElement)
        const elements = document.querySelectorAll<HTMLElement>('.dynamic-max-width')

        let newWidth = 1300
        if (source) {
            newWidth = source.clientWidth

            if (!newWidth) return

            elements.forEach((element) => {
                if (!element) return
                element.style.width = newWidth + 'px'
                element.style.maxWidth = newWidth + 'px'
            })
        }
    }

    const setSize = () => {
        setMaxWidth('.virtual-tour-wrapper')
        setMaxWidth('.building-chooser-wrapper')
        setMaxWidth('.unit-chooser-wrapper')
        setMaxWidth('.manual-slide-show-wrapper')
    }

    return {
        provide: {
            setMaxWidth: (source) => setMaxWidth(source),
            setSize: setSize
        }
    }
})
